/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.31/esri/copyright.txt for details.
*/
let n=0;function t(){return n++}function u(t=0){n=t}let o=0;function c(){return o++}function e(n=0){o=n}let f=0;function i(){return f++}function r(n=0){f=n}function l(){u(),e(),r()}export{i as nextBloomId,c as nextLinearGradientId,t as nextPatternId,r as resetBloomId,e as resetLinearGradientId,u as resetPatternId,l as resetSVGGlobalState};
